export default "__VITE_ASSET__6b17d500__"